import React from 'react';
import ResponsiveImage, { ImgContainer } from '@common/components/image';
import { CardProps, CardListFilterState } from '../types';
import PillContainer from '@common/components/card/PillContainer';
import ReviewStars from '@common/components/stars/reviewStars';
import { useSelector } from 'react-redux';
import TypeLabel from '@common/components/card/TypeLabel';
import { ElfsightWidget } from 'react-elfsight-widget';

const cardImageRatio = 'w45h28';

const Card = ({
  url,
  image,
  primaryPill,
  secondaryPill,
  priceData,
  promoPill,
  type,
  title,
  description,
  reviews,
  reviewsElfsightWidgetId,
  openInNewTab,
  externalIDs,
}: CardProps) => {
  const translations = useSelector(
    (state: CardListFilterState) => state.translations
  );

  let tourPrice = null;
  let originalPrice = null;

  if (priceData) {
    if (priceData.price) {
      tourPrice = Math.ceil(priceData.price).toLocaleString();
    }
    if (priceData.originalPrice) {
      originalPrice = Math.ceil(priceData.originalPrice).toLocaleString();
    }
  }

  const handleClick = () => {
    if (window.rudderstackExtensions && externalIDs) {
      window.rudderstackExtensions.trackItemClickedEvent(
        externalIDs,
        title,
        url
      );
    }
  };

  return (
    <div className='col-12 col-md-6 col-xxl-4 p-1'>
      <a
        href={url}
        className='tour d-block text-decoration-none h-100'
        target={openInNewTab ? '_blank' : '_self'}
        onClick={handleClick}
      >
        <div className='row no-gutters h-100 align-content-start align-items-end flex-column'>
          <div className='w-100'>
            <div className='tour__header d-block'>
              <ImgContainer cropRatio={cardImageRatio}>
                {image ? (
                  <ResponsiveImage {...image} ratio={cardImageRatio} />
                ) : null}
              </ImgContainer>
              <PillContainer
                primaryPill={primaryPill}
                secondaryPill={secondaryPill}
                promoPill={
                  promoPill && promoPill.isVisible ? promoPill : undefined
                }
              />
              <TypeLabel type={type} />
            </div>
          </div>
          <div className='w-100'>
            <div className='tour__body px-2 py-2'>
              <h3 className='tour__title text-uppercase font-weight-bold color-body m-0 pb-1'>
                {title}
              </h3>
              <div className='tour__description text-block'>
                <p>{description}</p>
              </div>
              {reviewsElfsightWidgetId ? (
                <div className='row pb-1'>
                  <div className='col-auto review-label elfsight-review-badge-widget-container'>
                    <ElfsightWidget
                      widgetId={reviewsElfsightWidgetId}
                      lazy
                      modern
                    />
                  </div>
                </div>
              ) : reviews ? (
                <div className='row pb-1'>
                  <div className='col-auto review-label'>
                    <ReviewStars score={reviews.avg} classes='review-star' />
                    <span className='text-uppercase d-inline-block pl-1 color-light-gray'>
                      {reviews.description}
                    </span>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div className='w-100 px-2 pb-2 mt-auto'>
            <div className='tour__footer'>
              <div className='row'>
                <div className='col-6 d-flex flex-column justify-content-end'>
                  <span className='btn btn-viewTour tour__btn'>
                    {translations && translations.viewTour
                      ? translations.viewTour
                      : 'View Tour'}
                  </span>
                </div>
                <div className='col-6'>
                  {priceData ? (
                    <div className='text-center'>
                      {originalPrice &&
                      tourPrice &&
                      originalPrice !== tourPrice ? (
                        <>
                          <div className='d-block'>
                            <p className='tour__old-price color-light-gray text-uppercase m-0'>
                              <span>{originalPrice}</span>{' '}
                              <span className='tour__currency'>
                                {priceData.currency}
                              </span>
                            </p>
                          </div>
                          <p className='tour__price-prefix text-uppercase font-small m-0 d-inline-block'>
                            {translations && translations.now
                              ? `${translations.now}`
                              : 'Now'}
                            &nbsp;
                          </p>
                        </>
                      ) : null}
                      {tourPrice ? (
                        <p className='tour__price m-0 text-uppercase font-weight-bold color-body d-inline-block'>
                          <span>{tourPrice}</span>{' '}
                          <span className='tour__currency'>
                            {priceData.currency}
                          </span>
                        </p>
                      ) : (
                        priceData.customText
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default Card;
